import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { Truncated } from './components';
import styles from './components/Truncated/Truncated.scss';
import { GenericNotification } from './GenericNotification';

export const uploadFinishedNotification =
  ({
    failedFilesCount,
    filesCount,
    fileName,
    targetName,
    isAutomaticResumeServerError,
    isConnectivityError,
    onTargetClick,
  }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          failedFilesCount === 0 ? (
            targetName ? (
              <FormattedMessage
                id="files-manager.upload-finished-with-target-notification"
                values={{
                  itemsCount: filesCount,
                  fileName: <Truncated>{fileName}</Truncated>,
                  targetName: (
                    <TextButton
                      className={styles.truncated}
                      as="a"
                      size="small"
                      underline="always"
                      onClick={onTargetClick}
                      skin="dark"
                      dataHook="notification-link"
                    >
                      {targetName}
                    </TextButton>
                  ),
                }}
              />
            ) : (
              <FormattedMessage
                id="files-manager.upload-finished-notification"
                values={{
                  itemsCount: filesCount,
                  fileName: <Truncated>{fileName}</Truncated>,
                }}
              />
            )
          ) : isConnectivityError ? (
            <FormattedMessage id="files-manager.upload-toaster-stopped-connectivity" />
          ) : isAutomaticResumeServerError ? (
            <FormattedMessage id="files-manager.upload-toaster-stopped" />
          ) : failedFilesCount === filesCount ? (
            <FormattedMessage id="files-manager.upload-all-failed-notification" values={{ failedFilesCount }} />
          ) : (
            <FormattedMessage
              id="files-manager.upload-some-failed-notification"
              values={{ failedFilesCount, filesCount }}
            />
          )
        }
        type={failedFilesCount === 0 ? NotificationType.Standard : NotificationType.Destructive}
      />
    );
